import React, { useState } from 'react';
import { clsx } from 'clsx';

import NavigationInformationHighlightedXsmall from '@strava/icons/NavigationInformationHighlightedXsmall';

import { useMRE } from '../../hooks/useMRE';

import styles from './Info.module.scss';

export const Info = () => {
  const { t } = useMRE();
  const [isOpen, setIsOpen] = useState(false);

  const links = [
    {
      id: 1,
      href: null,
      label: <>&copy; Intermap Technologies</>
    },
    {
      id: 2,
      href: 'https://www.mapbox.com/about/maps/',
      label: <>&copy; Mapbox</>
    },
    {
      id: 3,
      href: 'https://www.maxar.com',
      label: <>&copy; Maxar</>
    },
    {
      id: 4,
      href: 'https://www.openstreetmap.org/copyright/',
      label: <>&copy; OpenStreetMap</>
    },
    {
      id: 5,
      href: 'https://www.earthenv.org/DEM.html',
      label: <>&copy; EarthEnv-DEM90</>
    },
    {
      id: 6,
      href: 'https://apps.mapbox.com/feedback/?owner=strava&amp;id=cm1rtwclf00x401qv2ky2e5d2&amp;access_token=pk.eyJ1Ijoic3RyYXZhIiwiYSI6ImNtMWp3M2UyZDAydzIyam9zaTh6OTNiZm0ifQ.AOpRu_eeNKWg6r-4GS52Kw#/-76.61719/37.22873/12.83',
      label: t('mre.info.improve_this_map')
    }
  ];

  return (
    <div className={clsx(styles.info, { [styles.open as string]: isOpen })}>
      <button
        className={styles.infoIcon}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <NavigationInformationHighlightedXsmall />
      </button>
      {isOpen && (
        <ul className={styles.infoText}>
          {links.map(({ id, href, label }) => (
            <li key={id}>
              {href && (
                <a href={href} target="_blank" rel="noreferrer">
                  {label}
                </a>
              )}
              {!href && <>{label}</>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
